import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { RegisterModel } from 'common/models/page-models/register/register-final-model/register-data-model';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { RegisterFormWidgetService } from 'common/widget/student/register-form-widget.services';

@Injectable({
    providedIn: 'root'
})
export class RegisterFormResolver extends FormResolverService<RegisterModel> {
    constructor(
        protected fs: RegisterFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override getResolverMessage() {
        // console.log(this.router.url)
        // const route = this.manageState();
        const routerConfig = new RouteEnvelope();
        routerConfig['type'] = OperationType.CREATE;
        routerConfig['transferData'] = new WidgetModel();
        return routerConfig;
    }


    // override initWidget(envelopeType: any, transferData: any): WidgetModel {
    //     const widget = new WidgetModel();
    //     transferData.meta = new RegisterMetaModel().getMetaModel();
    //     this.fs.getFilterOptions(transferData.meta);
    //     widget.transferData = transferData;
    //     return widget;
    // }
}
